<div class="gbp-qa-customer-view-wrapper">
  <p-table
    #gbpQaTable
    [value]="allQuestions"
    [loading]="loading"
    sortMode="single"
    [globalFilterFields]="['questionText', 'storeCode', 'businessName']"
    dataKey="id"
    scrollable="true"
    [scrollHeight]="'calc(100vh - 477px)'"
    rowExpandMode="single"
    [lazy]="true"
    [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} "
    (onLazyLoad)="lazyLoadQuestions($event)"
    [rows]="pageSize"
    [totalRecords]="totalQuestionsCount"
    [showCurrentPageReport]="true"
  >
    <ng-template pTemplate="caption">
      <div class="flex-search-bar">
        <div class="search-bar-buttons">
          <div class="acct-search">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <span class="p-inputgroup">
                <input
                  class="input"
                  pInputText
                  type="text"
                  placeholder="Search by question text or answer text..."
                  [(ngModel)]="keyword"
                  [disabled]="false"
                  (input)="gbpQaTable.filterGlobal($event.target.value, 'contains')"
                />
                <button
                  pButton
                  type="button"
                  icon="fa fa-filter"
                  class="filter-button"
                  [ngStyle]="chipsArray.length > 0 && { color: SYSTEM_COLORS.$systemGreen }"
                  (click)="op.toggle($event)"
                ></button>
                <p-overlayPanel #op>
                  <ng-template pTemplate>
                    <div class="search-filter">
                      <app-table-filter [data]="filterData" (filterData)="onChipsRefresh($event)"></app-table-filter>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </span>
            </span>
          </div>
          <div class="button-div-flex">
            <button
              pButton
              label="EXPORT"
              class="p-button-outlined"
              iconPos="left"
              icon="fa fa-upload"
              (click)="exportData()"
            ></button>
          </div>
        </div>
      </div>
      <div class="chips-bar">
        <p-chip *ngFor="let chipText of chipsArray" [label]="chipText"></p-chip>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr *ngIf="allQuestions">
        <th class="smaller-columns">ID</th>
        <th class="wider-columns" pSortableColumn="questionText">
          QUESTION
          <p-sortIcon field="questionTexte"></p-sortIcon>
        </th>
        <th class="wider-columns" pSortableColumn="businessName">
          LOCATION
          <p-sortIcon field="businessName"></p-sortIcon>
        </th>
        <th class="smaller-columns" pSortableColumn="storeCode">
          STORE CODE
          <p-sortIcon field="storeCode"></p-sortIcon>
        </th>
        <th class="smaller-columns" pSortableColumn="createTime">
          DATE POSTED
          <p-sortIcon field="createTime"></p-sortIcon>
        </th>
        <th class="smaller-columns" pSortableColumn="ans_owner">
          OWNER ANSWER
          <p-sortIcon field="ans_owner"></p-sortIcon>
        </th>
        <th class="smaller-columns" pSortableColumn="ans_count_cust">
          CUSTOMER ANSWERS
          <p-sortIcon field="ans_count_cust"></p-sortIcon>
        </th>
        <th class="smaller-columns">ACTIONS</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-i="index" let-rowData>
      <tr>
        <td class="smaller-columns">
          {{ rowData._id }}
        </td>
        <td class="wider-columns">
          <div class="table-question">{{ rowData.questionText }}</div>
        </td>
        <td class="wider-columns">
          {{ rowData.businessName }}
        </td>
        <td class="smaller-columns">{{ rowData.storeCode }}</td>
        <td class="smaller-columns">
          {{
          rowData.scheduleTime
            ? rowData.scheduleTime?.strftime('%m/%d/%Y %H:%M')
            : rowData.createTime ? rowData.createTime?.strftime('%m/%d/%Y') :
              rowData._lastUpdatedAt.strftime('%m/%d/%Y')
          }}
        </td>
        <td class="smaller-columns">
          <div
            class="answer-button"
            (click)="rowData.ans_owner && openAnswers(rowData, 'owner')"
            [ngClass]="rowData.ans_owner ? 'answer-button-yes answer-button-pointer' : 'answer-button-no'"
          >
            {{ rowData.ans_owner > 0 ? 'YES' : 'NO' }}
          </div>
        </td>
        <td class="smaller-columns">
          <div
            (click)="rowData.ans_count_cust > 0 && openAnswers(rowData, 'customer')"
            class="answer-button"
            [ngClass]="rowData.ans_count_cust > 0 ? 'answer-button-yes answer-button-pointer' : 'answer-button-no'"
          >
            {{ rowData.ans_count_cust > 0 ? rowData.ans_count_cust : 'NO' }}
          </div>
        </td>
        <td class="table-actions smaller-columns">
          <ul class="table-actions-list">
            <li (click)="openReply(rowData)"
              [class.disable_add__reply]="!checkEditPerms">
              <i class="pi pi-pencil"></i>{{ rowData.ans_owner ? ' Edit Reply' : ' Add reply' }}
            </li>
          </ul>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
